import { create } from 'zustand';
import { setViewOnlyCheck } from '../../lib/api/client.js';

const KEY = 'indusketch.viewOnly';

interface InspectState {
  /** Kept per browser until switched off again. */
  readonly on: boolean;
  setOn: (on: boolean) => void;
}

function load(): boolean {
  try {
    return localStorage.getItem(KEY) === '1';
  } catch {
    return false;
  }
}

export const useInspectStore = create<InspectState>()((set) => ({
  on: load(),
  setOn(on) {
    try {
      localStorage.setItem(KEY, on ? '1' : '0');
    } catch {
      // Private mode: the switch lasts for this visit only.
    }
    set({ on });
  },
}));

/**
 * "View only": look into projects without changing them, e.g. an administrator in a customer
 * project or a user presenting their own planning. Nothing is saved or logged; a user stays
 * in the live room as a reader (seen, seeing the others), an administrator stays out of it.
 */
export const useViewOnly = (): boolean => useInspectStore((s) => s.on);

export const isViewOnly = (): boolean => useInspectStore.getState().on;

// Every request asks at the moment it is sent, so nothing slips through before a re-render.
setViewOnlyCheck(isViewOnly);
